import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import {
  INVOICESTATUS_ID,
  IPurchaseOrder,
  ORDERSTATUS_ID,
  RECEPTIONSTATUS_ID
} from '../purchase-order.interface';
import { PurchaseOrderService } from '../purchase-order.service';

@Component({
  templateUrl: './purchase-order-detail.component.html',
  selector: 'pg-purchase-order-detail'
})
export class PurchaseOrderDetailComponent extends TableActionsTemplate {
  visible = true;
  @Input() dataDocument: any;
  @Output() onHideData = new EventEmitter<boolean>();
  tableDetailSettings: ISettingsTable;
  detailPurchaseOrder;
  prueba: any[];
  precioTotal = 0;
  quantity = 0;
  quantityReceived = 0;
  constructor(private serviceBase: PurchaseOrderService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Detalle de los Productos',
      columns: [
        { header: 'Descripción', field: 'name' },
        { header: 'Cantidad', field: 'quantity' },
        { header: 'Cant. Recibida.', field: 'quantity_received' },
        { header: 'Cant. Facturada.', field: 'quantity_invoiced' },
        { header: 'Cant. Rechazada.', field: 'quantity_rejected' },
        { header: 'Precio Total', field: 'netTotal', pipe: 'Currency' },
        { header: 'Descuento', field: 'discount', pipe: 'Currency' },
        { header: 'Precio unitario', field: 'unitPrice', pipe: 'Currency' },
        { header: 'Unidad de medida', field: 'unitMeasure' }
      ]
    };
    this.initSubscriptions$();
    this.visible = true;
  }
  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrder[]) => {
        const id = data.findIndex(
          (item) => item['id'] == this.dataDocument['id']
        );
        this.table.data = data[id]['products'];
        this.detailPurchaseOrder = data[id];
        this.parseToTable(this.detailPurchaseOrder);
        this.calcularPrecioCompraTotal();
        this.calcularCantidadTotal();
        this.calcularCantidadRecibida();
      });
  }
  calcularPrecioCompraTotal() {
    this.precioTotal = 0;
    for (const item of this.detailPurchaseOrder['products']) {
      this.precioTotal += Number(item['netTotal']);
    }
  }
  calcularCantidadTotal() {
    this.quantity = 0;
    for (const item of this.detailPurchaseOrder['products']) {
      this.quantity += Number(item['quantity']);
    }
  }
  calcularCantidadRecibida() {
    this.quantityReceived = 0;
    for (const item of this.detailPurchaseOrder['products']) {
      this.quantityReceived += Number(item['quantity_received']);
    }
  }
  parseToTable(data) {
    data['orderStatusName'] = ORDERSTATUS_ID[data.orderStatusId];
    data['invoiceStatusName'] = INVOICESTATUS_ID[data.invoiceStatusId];
    data['receptionStatusName'] = RECEPTIONSTATUS_ID[data.receptionStatusId];
    this.detailPurchaseOrder = data;
  }

  onHideDataDialog() {
    this.visible = false;
    this.onHideData.emit();
  }
}
